import { SVGProps } from 'react';

const Reply = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 18v-2a4 4 0 0 0-4-4H4m5-5-5 5 5 5"
    />
  </svg>
);
export default Reply;
